module.exports = {
  publicPath: '/badges/ui',
  prefixPath: '/badges/ui/',
};
